import { Container, Row } from 'react-bootstrap';
import Config from '../config/config';
import { HomeCards } from './homeCards';
import './page.css';

export default function Home() {
    return (
        <div>
            <Container>
                <Row className="justify-content-md-center">
                    <HomeCards cards={Config.CARDS} />
                </Row>
            </Container>
        </div>
    );
}
